<template>
  <!-- 布局方式
       @author: 王汝鹏
       @date: 2019-9-15
   -->
  <div class="setting-item">
    <el-form-item label="是否添加下划线"> 
      <el-radio-group v-model="isUnderline" size="small">
        <el-radio-button :label=true>是</el-radio-button>
        <el-radio-button :label=false>否</el-radio-button>
      </el-radio-group>
    </el-form-item>
  </div>
</template>

<script>
// 导入value监听混入
import mixValueWatch from '@/mixins/common/mix_value_watch.js';
// 导入计算属性映射方法
import { mapComputed } from '@/mixins/common/mix_value_watch.js';
export default {
  mixins: [ mixValueWatch ],
  computed: {
    /** @name 布局方式
     *  @description 将 isUnderline 字段映射到当前 isUnderline 计算属性
     *  @return {String}
     *  @author 王汝鹏
     *  @version 2019-09-15
     */
    ...mapComputed({
      isUnderline: { 
        parent: i => i.renderOption,
        attr: "isUnderline" 
      }
    })
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Setting/render_setting/RenderIsUnderline.vue